// События пользователей. Например, нужно произвести какое-то действие один раз, больше не воспроизводить.
export const UserEvents = {
    // Закрыт промокод Яндекс Директ
    EVENT_CLOSE_YANDEX_DIRECT_PROMO: 1,
    // Закрыт промокод Яндекс Бизнес
    EVENT_CLOSE_YANDEX_BUSINESS_PROMO: 2,
    // Закрыто оповещение о расширении для браузера v2.0.0
    EVENT_CLOSE_POPUP_NEW_EXTENSION_V_2_0_0: 3,
    // Закрыто оповещение с анонсом Яндекс Бизнес
    EVENT_CLOSE_POPUP_YANDEX_BUSINESS: 4,
    EVENT_DONT_CHECK_PROJECT_COUNT: 5,
    // Закрыт баннер в PromoPult (удалён баннер)
    EVENT_CLOSE_BANNER_PROMOPULT: 6,
    // Закрыт баннер акции «Мартовский апгрейд с Keys.so и eLama» (01.03–31.03.2026)
    EVENT_CLOSE_BANNER_MARCH_ELAMA: 7,
    // Отображение баннера акции «Мартовский апгрейд с Keys.so и eLama» (01.03–31.03.2026) об успешной активации Проф
    EVENT_SHOW_BANNER_MATCH_ELAMA_COMPLETE: 8,
    // Нужно показать опрос обратной связи в чате поддержки (пользователь подходит под условия для показа опроса)
    EVENT_NEED_SHOW_FEEDBACK: 9,
    // Нужно показать popup с оповещением о окончании подписки
    EVENT_SHOW_POPUP_SUBSCRIPTION_EXPIRES: 10,
}
